import { useEffect, useState } from 'react';
import styles from 'styles/modules/popUps/Uploader.module.scss';
import Button from 'components/Button';
import CrosshatchLine from 'components/CrosshatchLine';
import { getFileTitle } from 'helpers/file';
import Input from 'components/Input';
// import File from 'components/svg/File';
import File from 'components/Svg/File';

export default function UploaderSettings({ file, fileSrc, onSubmit }) {
    const [title, setTitle] = useState(getFileTitle(file.name));

    const handleSubmit = (e) => {
        e.preventDefault();

        if (onSubmit) {
            onSubmit({
                title: title,
            });
        }
    };

    let preview;

    if (file.type.match('image.*')) {
        preview = (
            <div
                className={['col', styles.settingsPreview].join(' ')}
                style={{ backgroundImage: `url(${fileSrc})` }}
            />
        );
    } else {
        preview = (
            <div className={['col', styles.settingsPreview].join(' ')}>
                <File fill={'#aaa'} />
            </div>
        );
    }

    useEffect(() => {
        const handleKeyUp = (e) => {
            const pressed = e.key?.toLowerCase();
            if (pressed === 'enter') {
                handleSubmit(e);
            }
        };

        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    return (
        <div>
            <div className={styles.settingsRow}>
                {preview}

                <div className={['col', styles.settingsBody].join(' ')}>
                    <Input
                        value={title}
                        color={'dark'}
                        label={'Title'}
                        onChange={({ target: { value } }) =>
                            setTitle(value.trim())
                        }
                    />
                </div>
            </div>
            <div className={styles.cta}>
                <Button
                    title={'Confirm'}
                    onClick={handleSubmit}
                    disabled={title === ''}
                />
                <div className={styles.crosshatch}>
                    <CrosshatchLine />
                </div>
            </div>
        </div>
    );
}
